import { createAction } from 'typesafe-actions';

import { Underground } from 'shared/types/filters/geo';

export const addUndergroundStations = createAction('filters/addUndergroundStations')<Underground[]>();
